import React, { useEffect, useRef, useState } from "react";
import { Link } from 'react-router-dom';
import { Table, Row, Col, Card, CardBody, Container } from 'reactstrap';
import { TablePagination } from '../../Components/Pagination'
import { showToast } from '../../Components/Toast';
import Skeleton from "react-loading-skeleton";
import Image from '../../Components/Image'
import { getAllUsers } from "../../API/Backend";

export default function UserManagement() {

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [keyword, setKeyword] = useState("");
  const keywordRef = useRef("");

  useEffect(() => {
    fetchUsers();
  }, [update])

  const fetchUsers = (limit = 10, offset = 0, keyword = "") => {
    setLoading(true)
    setUsers([])
    getAllUsers({ limit: limit, offset: offset, ...(keyword && keyword.length && { search: keyword }) }).then(({ data }) => {
      if (data.data) {
        // console.log('banners', data)
        setUsers(data.data ? data.data.users : [])
        setCount(data.data ? data.data.count : 0)
      }
      else {
        showToast("error", "Request Failed", data.message)
      }
      setLoading(false)
    }).catch((err) => {
      showToast("error", "Request Failed", err.message)
      setLoading(false)
    })
  }

  const onPaginationChange = (currentPage) => {
    if (page !== currentPage) {
      setPage(currentPage);
      fetchUsers(limit, limit * (currentPage - 1), keyword)
    }
  }

  const searchByKeyword = (e) => {
    e.preventDefault();
    setKeyword(keywordRef.current.value);
    fetchUsers(limit, 0, keywordRef.current.value)
  }

  return (
    <Container fluid>
      <Row className="align-items-center mb-3">
        <Col>
          <h5 className="page-title">User Management</h5>
          <Card>
            <CardBody>
              <Row className="mb-3">
                <Col md="12">
                  <div className='d-flex align-items-center gap-5'>
                    <div className='table-size-container'>
                      <span>Showing</span>
                      <select className='table-size-control' value={limit} onChange={(e) => { setLimit(Number(e.target.value)); fetchUsers(Number(e.target.value), 0, "") }}>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                      </select>
                      <span>entries</span>
                    </div>
                    <div className="table-search-box">
                      <input type="search" id="customSearch" placeholder="Search Here..." ref={keywordRef} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); searchByKeyword(e); } }} />
                      <button disabled={loading} onClick={(e) => { searchByKeyword(e) }}><i className="ri-search-line"></i></button>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Table>
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>Name</th>
                        <th className="text-center">Cart</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        loading ?
                          [...Array(15)].map((a, i) => {
                            return <tr key={i}>
                              <td><div><Skeleton height={40} width={80} className='me-2' /></div></td>
                              <td><Skeleton height={12} width={80} /></td>
                              <td><Skeleton height={20} width={60} /></td>
                              <td><Skeleton height={30} width={60} /></td>
                            </tr>
                          }) :
                          !users.length ?
                            <tr><td colSpan="4" className="text-center fs-12 fw-600"><span className="d-flex align-items-center justify-content-center"><i className="ri-error-warning-line text-danger fs-22 fw-300 me-2"></i> No users found</span></td></tr> :
                            users.map((user, i) => (
                              <tr key={user._id}>
                                <td>{i + 1}</td>
                                <td>{user.firstName && user.lastName ? user.firstName + " " + user.lastName : "N/A"} {user.isGuest ? "(Guest)" : ""}</td>
                                <td className="text-center">
                                  {user.cartId ? <Link className="btn btn-primary btn-rounded" to={`/users/cart/${user._id}`}>View</Link> : "Cart is Empty"}
                                </td>
                              </tr>
                            ))
                      }
                    </tbody>
                  </Table>
                </Col>
              </Row>
              <TablePagination limit={limit} page={page} currentRecords={users.length} total={count} loading={false} onPaginationChange={(p) => onPaginationChange(p)} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
